import { convertSpellNameToUpper } from './colHelpers';
import { Province, Sot, Spell } from '../../../@types/KingdomResponse';
import { KanbanColumn, KanbanItem, KdKanban } from '../../../@types/State';

export const alreadyExistsInSot = (sot: Sot | null, OpName: string) => {
  if (!sot) return false;
  const exists = (x: string, s: Spell) => {
    return convertSpellNameToUpper(s.name) === x;
  };
  const existsInGoodSpells = sot?.badSpells?.some((s: Spell) =>
    exists(OpName, s)
  );
  const existsInBadSpells = sot?.goodSpells?.some((s: Spell) =>
    exists(OpName, s)
  );
  const noPlague = OpName === 'Cure Plague' && !sot?.plague;
  return existsInGoodSpells || existsInBadSpells || noPlague;
};

export const enrichProvinces = (
  plan: KdKanban | undefined,
  dataSet: Province[] | undefined
) => {
  if (!dataSet) return null;
  const newProvinces: Province[] = dataSet.map((p: Province) => {
    return { ...p };
  });
  const addOpsToDo = (allOps: string[] | null, p: Province) => {
    if (!allOps) return null;
    return allOps.filter((op: string) => {
      return !alreadyExistsInSot(p.sot, op);
    });
  };

  if (plan) {
    plan.columns.forEach((c: KanbanColumn) => {
      c.items.forEach((i: KanbanItem) => {
        const province = newProvinces.find(
          (p: Province) => p.id === i.province.id
        );
        if (province) {
          province['group'] = c.title === 'Unassigned' ? '' : c.title;
          province['note'] = i.content;
          province['requiredOps'] = addOpsToDo(
            i.province.requiredOps,
            province
          );
          province['requiredObjectives'] = i.province.requiredObjectives;
        }
      });
    });
  }
  return newProvinces;
};

export const getMaxSpellCount = (dataSet: Province[] | undefined) => {
  let maxGood = 0;
  let maxBad = 0;
  if (dataSet && dataSet.length > 0)
    dataSet.forEach((province: Province) => {
      if (province.sot) {
        maxGood = Math.max(maxGood, province.sot.goodSpells.length);
        maxBad = Math.max(maxBad, province.sot.badSpells.length);
      }
    });
  return [maxGood, maxBad];
};
